/** 与 EventIF.Type 一致，用于列表描述，避免循环引用 EventIF 类 */
export const IFBranch = {
  VarIndex: 0,
  Flower: 1,
  VarEx: 2,
  Mouse: 3,
  Platform: 4,
  Task: 5,
  Pay: 6,
  Mall: 7,
  LimiteMall: 8,
} as const

export type IFBranchType = (typeof IFBranch)[keyof typeof IFBranch]

export function inferIfBranch(parameter: string[] | undefined): IFBranchType | null {
  if (!parameter?.length) return null
  const p0 = parameter[0] ?? ''
  if (parameter.length === 7 && parameter[6]?.startsWith('TA')) {
    return IFBranch.Task
  }
  if (!Number.isNaN(parseInt(p0, 10)) && p0 !== '') {
    return IFBranch.VarIndex
  }
  const pre = p0.substring(0, 2)
  switch (pre) {
    case 'EX':
      return IFBranch.VarEx
    case 'FL':
      return IFBranch.Flower
    case 'MO':
      return IFBranch.Mouse
    case 'PT':
      return IFBranch.Platform
    case 'PA':
      return IFBranch.Pay
    case 'ST':
      return IFBranch.Mall
    case 'LT':
      return IFBranch.LimiteMall
    default:
      return null
  }
}
